module.exports = __webpack_public_path__ + "static/media/loginBg.20e650b9.svg";